import { Typography } from '@mui/material';
import React from 'react';

import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import { TTruncatedTextProps } from '@/shared/components/ui/truncated-text/truncated-text.types';
import { truncateText } from '@/shared/utils/truncate-text';

const DEFAULT_MAX_LENGTH = 16;

export const TruncatedText: React.FC<TTruncatedTextProps> = ({
  text,
  maxLength = DEFAULT_MAX_LENGTH,
  disableTooltip,
  truncateFromBack,
  tooltipPlacement,
  tooltipTextAlign,
  endAdornment,
  ...rest
}) => {
  const { shouldTruncate, truncatedText } = truncateText(
    text,
    maxLength,
    truncateFromBack,
  );

  const getTooltip = () => {
    if (disableTooltip) {
      return '';
    }

    return shouldTruncate ? text : '';
  };

  return (
    <Tooltip
      title={getTooltip()}
      arrow
      noMaxWidth
      placement={tooltipPlacement}
      textAlign={tooltipTextAlign}
    >
      <Typography {...rest}>
        {truncatedText}
        {endAdornment}
      </Typography>
    </Tooltip>
  );
};
